"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchPageBase = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var SupportPortalTemplates_1 = require("../../../SupportPortalTemplates");
var SearchResultsTable_1 = require("./SearchResultsTable");
var Pagination_1 = require("../../../helpers/Pagination");
var SearchPageBase = /** @class */ (function (_super) {
    __extends(SearchPageBase, _super);
    function SearchPageBase(props) {
        var _this = _super.call(this, props) || this;
        _this.supportPortalTemplates = new SupportPortalTemplates_1.SupportPortalTemplates();
        _this.handleSearch = function () {
            var result = _this.validate(_this.state.searchParameters);
            if (!result.valid) {
                alert(result.message);
                return;
            }
            _this.setState({ offset: 0 }, _this.search);
        };
        _this.logAgentActivity = function (reference) {
            if (_this.props.logAgentActivity) {
                _this.props.logAgentActivity(reference);
            }
        };
        _this.search = function () {
            var _a = _this.state, searchParameters = _a.searchParameters, limit = _a.limit, offset = _a.offset;
            _this.setState({ loading: true });
            _this.onSearch(searchParameters, limit, offset);
        };
        _this.handleClickPrevious = function () {
            _this.setState(function (state) { return ({ offset: Math.max(0, state.offset - state.limit) }); }, _this.search);
        };
        _this.handleClickNext = function () {
            _this.setState(function (state) { return ({
                offset: state.offset + state.limit < state.searchResult.count
                    ? state.offset + state.limit
                    : state.offset
            }); }, _this.search);
        };
        _this.handleClickPageNumber = function (page) {
            _this.setState(function (state) { return ({ offset: state.limit * (page - 1) }); }, _this.search);
        };
        _this.authorize = _this.authorize.bind(_this);
        _this.renderPagination = _this.renderPagination.bind(_this);
        _this.renderSpinner = _this.renderSpinner.bind(_this);
        _this.state = {
            searchResult: { count: 0, results: [] },
            limit: 10,
            offset: 0,
            loading: false,
            noResultError: false
        };
        return _this;
    }
    SearchPageBase.prototype.authorize = function () {
        var customerSearchRoles = [
            "Administrator",
            "Claims_Handler",
            "Fraud",
            "CSR_Lead",
            "CSR",
            "Support",
            "Read_Only"
        ];
        var hasCustomerSearchAccess = this.supportPortalTemplates.userHasRole(customerSearchRoles);
        var hasPricingAccess = this.supportPortalTemplates.userHasRole(["Pricing"]);
        if (!hasCustomerSearchAccess && !hasPricingAccess) {
            return this.supportPortalTemplates.renderErrorPage();
        }
        if (hasPricingAccess && !hasCustomerSearchAccess) {
            window.location.href = "/decompressData";
            return null;
        }
        return null;
    };
    SearchPageBase.prototype.renderPagination = function () {
        return ((0, jsx_runtime_1.jsx)(Pagination_1.default, { limit: this.state.limit, offset: this.state.offset, total: this.state.searchResult.count, onClickPrevious: this.handleClickPrevious, onClickNext: this.handleClickNext, onClickPageNumber: this.handleClickPageNumber }));
    };
    SearchPageBase.prototype.renderSpinner = function () {
        return this.state.loading
            ? this.supportPortalTemplates.renderSpinner()
            : this.noResultCondition();
    };
    SearchPageBase.prototype.noResultCondition = function () {
        return this.state.noResultError
            ? (0, jsx_runtime_1.jsx)("div", { className: "alert alert-danger", children: "No results found" })
            : ((0, jsx_runtime_1.jsx)(SearchResultsTable_1.SearchResultsTable, { logAgentActivity: this.logAgentActivity, customers: this.state.searchResult.results, search: this.handleSearch }));
    };
    return SearchPageBase;
}(React.Component));
exports.SearchPageBase = SearchPageBase;
//# sourceMappingURL=SearchPageBase.js.map